import React from 'react';

import { PrismicRichText } from '@prismicio/react';
import { H4 } from '@repo/ui/components/Typography';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import SectionTitleAndText from 'components/Landing/SectionTitleAndText/SectionTitleAndText';
import { getMediaCdnUrl } from 'global/prismicUtils';

import { Wrapper, Item, Image, Text, ItemTitleWrapper } from './styles';

const ImageItem = ({ item, textAlign, imageType }) => {
  const url = item.link?.url;

  return (
    <Item as={url ? 'a' : 'div'} href={url} textAlign={textAlign}>
      <Image
        alt={item.image?.alt}
        imageType={imageType}
        src={getMediaCdnUrl(item.image?.url)}
      />
      <ItemTitleWrapper>
        <H4>
          <strong>{item.title}</strong>
        </H4>
      </ItemTitleWrapper>
      <Text as="div">
        <PrismicRichText field={item.text} />
      </Text>
    </Item>
  );
};

const ImageRow = ({ slice }) => {
  const textAlign = slice.primary.textAlign || 'left';
  const imageType = slice.primary.imageType || 'fullWidth';

  return (
    <ContentWrapper className="image-row" customWidth="1344px" slice={slice}>
      <SectionTitleAndText slice={slice} />
      <Wrapper
        hasMarginTop={!!(slice.primary.title || slice.primary.text?.length)}
        numberOfItems={slice.items.length}
      >
        {slice.items.map((item, index) => (
          <ImageItem
            key={index}
            imageType={imageType}
            item={item}
            textAlign={textAlign}
          />
        ))}
      </Wrapper>
    </ContentWrapper>
  );
};

export default ImageRow;
